<div class="transit-detail-container">
  <!-- Header Section -->
  <div class="header-section">
    <div class="header-content">
      <div class="back-button" (click)="goBack()">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path d="M19 12H5M12 19l-7-7 7-7"/>
        </svg>
        <span>Back</span>
      </div>
      
      <div class="shipment-info">
        <div class="shipment-header">
          <h1 class="shipment-title">
            #{{ summaryDetails.shipment_id ? summaryDetails.shipment_id : '--' }} - {{ summaryDetails.shipped_to ? summaryDetails.shipped_to : '--' }}
          </h1>
          <div class="status-badge" [ngClass]="summaryDetails.is_transit ? 'status-transit' : 'status-completed'">
            {{ summaryDetails.is_transit ? 'In Transit' : 'Completed' }}
          </div>
        </div>
        
        <div class="shipment-details">
          <div class="detail-item">
            <div class="detail-icon">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4"/>
              </svg>
            </div>
            <div class="detail-content">
              <span class="detail-label">Quantity Shipped</span>
              <span class="detail-value">{{ summaryDetails.quantity }}</span>
            </div>
          </div>
          
          <div class="detail-item">
            <div class="detail-icon">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M8 2v4M16 2v4M3 10h18M5 4h14a2 2 0 012 2v14a2 2 0 01-2 2H5a2 2 0 01-2-2V6a2 2 0 012-2z"/>
              </svg>
            </div>
            <div class="detail-content">
              <span class="detail-label" *ngIf="summaryDetails.is_transit">Shipped Date</span>
              <span class="detail-label" *ngIf="!summaryDetails.is_transit">Delivered Date</span>
              <span class="detail-value">
                {{ summaryDetails.is_transit ? 
                  (summaryDetails.shipped_at ? timestampFormat(summaryDetails.shipped_at, "DD/MM/YYYY") : '-- --') :
                  (summaryDetails.delivered_at ? timestampFormat(summaryDetails.delivered_at, "DD/MM/YYYY") : '-- --')
                }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Products Section -->
  <div *ngIf="isSummaryProducts" class="products-section">
    <div class="section-header">
      <h2 class="section-title">Produssssssscts</h2>
      <div class="search-controls">
        <form class="search-block" (submit)="onSearchSubmit()">
          <div class="search-input">
            <input 
              type="text" 
              [(ngModel)]="searchInput" 
              name="search" 
              placeholder="Search by product name"
            >
          </div>
          <button type="submit" class="icon-btn">
            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M15.2513 12.9228L16.8527 14.5242C17.4953 15.1668 17.4953 16.2086 16.8527 16.8512C16.2101 17.4938 15.1683 17.4938 14.5257 16.8512L12.9243 15.2498M0.667969 7.74984C0.667969 3.83782 3.83929 0.666504 7.7513 0.666504C11.6633 0.666504 14.8346 3.83782 14.8346 7.74984C14.8346 11.6619 11.6633 14.8332 7.7513 14.8332C3.83929 14.8332 0.667969 11.6619 0.667969 7.74984Z" stroke="currentColor" stroke-width="1.25" stroke-linecap="round"/>
            </svg>
          </button>
        </form>
        <button type="button" class="reset-btn" (click)="reset($event)">
          Reset
        </button>
      </div>
    </div>

    <!-- Modern Two-Level Accordion Table -->
    <div class="accordion-table-container" *ngIf="isFilterResult">
      <div class="accordion-table">
        <!-- Table Header -->
        <div class="table-header">
          <div class="header-row">
            <div class="header-cell expand-col"></div>
            <div class="header-cell product-col">Product</div>
            <div class="header-cell stats-col">Quantity Summary</div>
          </div>
        </div>

        <!-- Accordion Items -->
        <div class="accordion-items">
          <div class="accordion-item" *ngFor="let product of summaryProducts" [class.expanded]="product.expanded">
            <!-- Level 1: Product Row -->
            <div class="product-row" (click)="onAccordionChange($event, product.id)">
              <div class="product-cell expand-cell">
                <div class="accordion-toggle">
                  <svg class="accordion-arrow" [class.rotated]="product.expanded" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <polyline points="6,9 12,15 18,9"></polyline>
                  </svg>
                </div>
              </div>
              <div class="product-cell product-info">
                <div class="product-details">
                  <div class="product-icon">
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4"/>
                    </svg>
                  </div>
                  <div class="product-text">
                    <h4 class="product-name">{{ product.name }}</h4>
                    <p class="product-id">ID: {{ product.id }}</p>
                  </div>
                </div>
              </div>
              <div class="product-cell stats-info">
                <div class="stats-badges">
                  <div class="stat-badge quantity">
                    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M9 12l2 2 4-4M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z"/>
                    </svg>
                    <span>{{ product.quantity }} Total</span>
                  </div>
                </div>
              </div>
            </div>

            <!-- Level 2: Stock Items -->
            <div class="stock-items" [class.show]="product.expanded">
              <div class="stock-header">
                <h5 class="stock-title">Individual Stock Items</h5>
                <div class="stock-count">{{ product.product_stocks?.length || 0 }} items</div>
              </div>
              
              <!-- Stock Items Column Headers -->
              <div class="stock-column-headers">
                <div class="stock-header-row">
                  <div class="stock-header-cell expand-col"></div>
                  <div class="stock-header-cell rfid-col">RFID</div>
                  <div class="stock-header-cell batch-col">Batch Number</div>
                  <div class="stock-header-cell expiry-col">Expiry Date</div>
                  <div class="stock-header-cell status-col">Status</div>
                  <div class="stock-header-cell updated-col">Last Updated</div>
                </div>
              </div>
              
              <div class="stock-list">
                <div class="stock-item" *ngFor="let stock of product.product_stocks">
                  <!-- Stock Item Row -->
                  <div class="stock-row">
                    <div class="stock-cell expand-cell">
                      <!-- Empty expand cell - no arrow needed -->
                    </div>
                    <div class="stock-cell rfid-cell">
                      <div class="stock-info">
                        <span class="rfid-text">{{ stock.rfid || '--' }}</span>
                      </div>
                    </div>
                    <div class="stock-cell batch-cell">
                      <span class="batch-text">{{ stock.batch_no || '--' }}</span>
                    </div>
                    <div class="stock-cell expiry-cell">
                      <span class="expiry-text">{{ timestampFormat(stock.expiry_date, "YYYY/MM/DD") || '--' }}</span>
                    </div>
                    <div class="stock-cell status-cell">
                      <div class="status-container">
                        <span class="status-badge" [ngClass]="'status-' + (stock.status || 'active')">{{ stock.status || 'Active' }}</span>
                      </div>
                    </div>
                    <div class="stock-cell updated-cell">
                      <span class="updated-text">{{ stock.last_updated_at || '--' }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- No Results State -->
    <div *ngIf="!isFilterResult" class="no-results-container">
      <div class="no-results">
        <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="32" cy="32" r="30" stroke="#e5e7eb" stroke-width="2"/>
          <path d="M32 20V32M32 44H32.01" stroke="#9ca3af" stroke-width="2" stroke-linecap="round"/>
        </svg>
        <h3 class="no-results-title">No records found</h3>
        <p class="no-results-text">No products match your search criteria</p>
      </div>
    </div>

    <!-- Pagination -->
    <div *ngIf="totalPages > 1 && isSummaryProducts" class="pagination-container">
      <app-pagination [totalPages]="totalPages" (queryPage)="getQueryPage($event)"></app-pagination>
    </div>
  </div>

  <!-- Empty State -->
  <div *ngIf="!isSummaryProducts" class="empty-state">
    <div class="empty-state-content">
      <svg width="80" height="80" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1">
        <path d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4"/>
      </svg>
      <h2 class="empty-state-title">No stock available</h2>
      <p class="empty-state-subtitle">Discover the available stock within this shipment</p>
    </div>
  </div>
</div>